import React from 'react';

interface WordLevelDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const WordLevelDialog: React.FC<WordLevelDialogProps> = ({ isOpen, onClose }) => {
  // CEFR levels data for the dialog
  const cefrLevels = [
    {
      level: 'A1',
      name: 'Beginner',
      description: 'Can understand and use familiar everyday expressions and very basic phrases.',
      color: '#4CAF50'
    },
    {
      level: 'A2',
      name: 'Elementary',
      description: 'Can communicate in simple and routine tasks requiring a simple exchange of information.',
      color: '#8BC34A'
    },
    {
      level: 'B1',
      name: 'Intermediate',
      description: 'Can deal with most situations likely to arise while travelling in an area where the language is spoken.',
      color: '#FFC107'
    },
    {
      level: 'B2',
      name: 'Upper Intermediate',
      description: 'Can interact with a degree of fluency and spontaneity that makes regular interaction with native speakers possible.',
      color: '#FF9800'
    },
    {
      level: 'C1',
      name: 'Advanced',
      description: 'Can express ideas fluently and spontaneously without much obvious searching for expressions.',
      color: '#F44336'
    },
    {
      level: 'C2',
      name: 'Proficient',
      description: 'Can understand with ease virtually everything heard or read. Can express very fluently and precisely.',
      color: '#9C27B0'
    }
  ];

  if (!isOpen) {
    return null;
  }

  return (
    <div className="popup-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div className="popup-content" style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '20px',
        margin: '20px',
        maxWidth: '90%',
        maxHeight: '80%',
        overflow: 'auto',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666'
          }}
        >
          ×
        </button>
        <div style={{ marginTop: '10px' }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: 'bold', 
            margin: '0 0 15px 0', 
            color: '#333',
            textAlign: 'center'
          }}>
            CEFR Language Levels
          </h2>
          <p style={{ 
            fontSize: '14px', 
            color: '#666', 
            margin: '0 0 20px 0',
            textAlign: 'center',
            lineHeight: '1.4'
          }}>
            The Common European Framework of Reference (CEFR) defines language proficiency levels from A1 (beginner) to C2 (proficient).
          </p>
          
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '13px'
            }}>
              <tbody>
                {cefrLevels.map((level, index) => (
                  <React.Fragment key={level.level}>
                    {/* First row: Level and Name */}
                    <tr style={{ 
                      borderBottom: '1px solid #eee',
                      backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'
                    }}>
                      <td style={{ 
                        padding: '12px 10px 6px 10px', 
                        verticalAlign: 'middle',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <span style={{
                          backgroundColor: level.color,
                          color: 'white',
                          padding: '6px 10px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          display: 'inline-block',
                          minWidth: '35px',
                          textAlign: 'center'
                        }}>
                          {level.level}
                        </span>
                        <span style={{ 
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '14px'
                        }}>
                          {level.name}
                        </span>
                      </td>
                    </tr>
                    {/* Second row: Description */}
                    <tr style={{ 
                      borderBottom: '2px solid #dee2e6',
                      backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'
                    }}>
                      <td style={{ 
                        padding: '6px 10px 12px 10px', 
                        verticalAlign: 'top',
                        color: '#666',
                        lineHeight: '1.4',
                        fontSize: '13px',
                        paddingLeft: '55px' // Align with the name text
                      }}>
                        {level.description}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Close button at the bottom */}
          <div style={{ 
            textAlign: 'center', 
            marginTop: '20px', 
            paddingTop: '15px', 
            borderTop: '1px solid #eee' 
          }}>
            <button
              onClick={onClose}
              style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                minWidth: '80px'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#0056b3';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#007bff';
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordLevelDialog; 